<template>
	<div class="flex-fill w-100 card" v-if="chartData.length > 0">
  	  	<div class="card-header">
  	    	<h5 class="mb-0 card-title">Nombre d'annotations et de tags par utilisateur</h5>
      	</div>
		<div class="p-3 card-body">
   			<GChart
				:settings="{packages: ['corechart', 'bar']}"
			    :data="chartData"
			    :options="chartOptions"
			    :resizeDebounce="300"
			    :createChart="(el, google) => new google.visualization.ColumnChart(el)" />
   	  	</div>
   	</div>
</template>

<script>
import {GChart} from 'vue-google-charts'

export default {
	components: {
	    GChart
	},
	data () {
	    return {
	    	chartData: [],
			chartOptions: {
			  	width: '100%',
			  	height: '300',
			  	colors: ['#17a2b8', '#e8eaed'],
			  	hAxis: {
					slantedText: true,
		          	slantedTextAngle: 45,
		        },
		        vAxis: {
		        	gridlines: {
		        		count: 0
		        	},
		        	format: 'short'
		        },
		        chartArea: {
		        	left: '6%',
		        	right: '20%',
		        	top: 10,
		        	height: '70%'
		        }
			}
		}
	},
	created() {
   		axios.get('/userPerformance').then(response => {
   			this.chartData = response.data;
        }).catch(err => {
            console.log(err)
        })
	},
}
</script>